
// Mutator
export const setErrors = ([name, data],  { formState } ) => {
  formState.submitErrors = { ...(formState.submitErrors || {}), ...{[name]: data} }
}



// WEBPACK FOOTER //
// ./src/components/form/mutators.js